import { findCompanyId } from "../../infrastructure/repository/company-repository";
import {
  findEmployeesWithFields,
  updateBenefitModel,
} from "../../infrastructure/employees-cache";
import { displayActiveEmployees } from "./displays/display-active-employees";
import { hideModal } from "../commons/hide-modal";
import { showSuccessMessage } from "../commons/show-success-message";
import { showErrorMessage } from "../commons/show-error-message";
import { logError, addContextLog } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";
import { findModels } from "../../infrastructure/repository/benefit-models-repository";
import { deliverBagToEmployees } from "../benefit-plan/deliver-bag-from-existant-in-model";
import { displayUploadEmployeesPage } from "./displays/display-upload-employees-page";

export async function changeBenefitModel(
  employeeIds,
  modelId,
  currentFilters,
  fromInvite
) {
  try {
    const companyId = await findCompanyId();
    const { data: models } = await findModels();
    const employees = await findEmployeesWithFields({ companyId });
    const selectedEmployees = employeeIds.reduce((acc, curr) => {
      const employeeFound = employees.find(({ id }) => id === curr);
      if (employeeFound) {
        return [...acc, employeeFound];
      }
      return acc;
    }, []);
    const targetModel = models.find(({ id }) => id === modelId) || {
      benefitBagConfig: [],
    };
    const { benefitBagConfig } = targetModel;
    const activeBags = benefitBagConfig.filter(
      ({ state }) => state === "active"
    );

    const updateAction = async () => {
      try {
        await updateBenefitModel({ companyId, employeeIds, modelId });
        addContextLog("info", "changeBenefitModel", "request", {
          companyId,
          employeeIds,
          modelId,
        });

        showSuccessMessage(
          translate("employees-section.change-benefit-model-success")
        );

        hideModal();
      } catch (e) {
        logError(e, `Error to changeBenefitModel in model ${modelId}`);
        showErrorMessage(
          translate("common-messages.basic-error-message"),
          true
        );
      }
    };

    if (activeBags.length > 0 && !fromInvite) {
      deliverBagToEmployees({
        targetModel,
        employees: selectedEmployees,
        activeBags,
        onConfirm: updateAction,
        navigateWhenDoneTo: () =>
          displayActiveEmployees({ employeeFilter: currentFilters }),
      });
    } else {
      await updateAction();

      if (!fromInvite) {
        displayActiveEmployees({ employeeFilter: currentFilters });
      } else {
        displayUploadEmployeesPage(1);
      }
    }
  } catch (e) {
    logError(e, `Error to changeBenefitModel in model ${modelId}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
